import SettingsPage from './screens/settings_page/SettingsPage';
import './App.scss';

function App() {
  return <SettingsPage />;
}

export default App;
